import { render } from "./TheFooter.vue?vue&type=template&id=2e95fd82&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=2e95fd82&scoped=true&lang=css"
import "./TheFooter.vue?vue&type=style&index=1&id=2e95fd82&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e95fd82"]])

export default __exports__